// AUTO-GENERATED by scripts/genVersion.cjs — do not edit.
export const BUILD_ID = "2026-11-05T15-27-04-006Z";
export const GIT_SHA = "6256d18";
